import Link from "next/link";
import Banner from "@/components/common/Banner/Banner";
import Layout from "@/components/layout/Layout";
import SeoHeader from "@/components/common/Seo/SeoHeader";
import { Button } from "@/components/common/Button";
import cn from "classnames";
import { helpCenterLink } from "@/constant";
import { HiOutlineExternalLink } from "react-icons/hi";
import { contactData } from "../data/contact.repository";
import classes from "../styles/Contact.module.scss";
import { initIntercom, openIntercomWidget } from "@/helper/helper";
const Contact = () => {
  initIntercom();
  return <Layout nav footer data-sentry-element="Layout" data-sentry-component="Contact" data-sentry-source-file="Contact.tsx">
      <SeoHeader seoTitle="Contact" noIndex={true} data-sentry-element="SeoHeader" data-sentry-source-file="Contact.tsx" />
      <Banner type="multi" title="Contact Us" data-sentry-element="Banner" data-sentry-source-file="Contact.tsx" />
      <div className={classes.wrapper}>
        <div className={cn(classes.flex, classes.contact)}>
          {contactData.map(({
          id,
          icon,
          title,
          link,
          linkText
        }) => <div key={id} className={cn(classes.flexItem, classes.contactItem)}>
              <img src={icon} />
              <h3>{title}</h3>
              <a href={link} target="blank">
                {linkText}
              </a>
            </div>)}
        </div>

        <h2 className={classes.helpTitle}>How can we help you?</h2>
        <div className={cn(classes.flex, classes.help)}>
          <div className={cn(classes.flexItem, classes.helpItem)}>

            <img src={"/common/contact_help-center.svg"} />
            <div>
              <h3>Help Center</h3>
              <p>Get answers and resources</p>
            </div>
            <div className={cn(classes.actionItem, classes.helpCenterLink)}>
              <Link target={"_blank"} href={helpCenterLink} data-sentry-element="Link" data-sentry-source-file="Contact.tsx">
                Visit Page
                <HiOutlineExternalLink size={20} data-sentry-element="HiOutlineExternalLink" data-sentry-source-file="Contact.tsx" />
              </Link>
            </div>
          </div>
          <div className={cn(classes.flexItem, classes.helpItem)}>

            <img src={"/common/contact_customer-support.svg"} />
            <div>
              <h3>Contact Customer Support</h3>
              <p>Reach out to us</p>
            </div>
            <Button onClick={() => openIntercomWidget()} title="Contact Support" className={cn(classes.actionItem, classes.contactSupportButton)} variant="borderless" data-sentry-element="Button" data-sentry-source-file="Contact.tsx" />
          </div>
        </div>
      </div>
    </Layout>;
};
export default Contact;